import {fileTypes} from "../../pages/create-project-page-new/enums";
import {Stack, Typography} from "@mui/material";
import {FileUploader} from "react-drag-drop-files";
import {IconFileUpload} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";
import {toast} from "react-toastify";


const allFileTypes = fileTypes.flatMap((group) =>
  group.extensions.map((ext) => ext?.extension?.replaceAll(".", "")?.toUpperCase())
);

export const DragAndDropFiles = ({multiple = false, maxFileSize = null, disabled = false, maxFiles = 1, types = [...allFileTypes], onUpdate = (file) => {}}) => {

  return (
    <FileUploader
      multiple={multiple}
      disabled={disabled}
      handleChange={(file) => {
        try {
          console.log("File", file)
          if (file?.size) {
            const sizeInMB = file?.size / (1024 * 1024);
            console.log(sizeInMB, maxFileSize, maxFileSize === null || sizeInMB <= maxFileSize)
            if (maxFileSize === null || sizeInMB <= maxFileSize) {

              onUpdate(file);
              // setErrorFile(false);
            } else {
              toast.error(`File size exceeds the limit of ${maxFileSize} MB.`);
              // setErrorFile(true);
            }
          }
        } catch (e) {
          console.log(e);
          // setErrorFile(true);
        }
      }}
      name="file"
      types={types}
    >
      <Stack
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        className={"drag-n-drop-file"}
        gap={1}
        sx={{
          mt: 1, p: 2,
          border: 2,
          borderStyle: "dashed",
          borderColor: disabled ? grey[600] : "primary.main",
          borderRadius: 5,
          minHeight: {xs: "10dvh", md: "20dvh"},
          textAlign: "center",
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? grey[600] : "primary.main",
          bgcolor: disabled ? grey[100] : "#5271FF22"
        }}
      >
        <IconFileUpload size={35} />
        <Typography fontWeight={"bold"} color={"inherit"} textTransform={"uppercase"}
                    fontSize={{xs: 14, md: 18}}>
          Choose file <Typography component={"span"} color={"inherit"} fontWeight={"inherit"} textTransform={"inherit"} fontSize={"inherit"} sx={{display: {xs: "none", md: "inline"} }}>or drop it here.</Typography>
        </Typography>
        <Typography color={"inherit"} fontSize={{xs: 12, md: 15}}>Maximum number of files: {maxFiles || 1} files.</Typography>
        <Typography color={"inherit"} fontSize={{xs: 12, md: 15}}>Size limit per file: {maxFileSize || 100}MB.</Typography>
        <Typography color={"inherit"} textTransform={"lowercase"} fontSize={{xs: 12, md: 15}}>
          Accepted file types: {types?.slice(0, 5)?.join(", ")} {types?.length > 5 ? " and more" : ""}
        </Typography>
      </Stack>
    </FileUploader>
  )
}